function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPeopleReceptionFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.038 7.654a1.654 1.654 0 10-1.653 1.654v2l-.189-.005a3.654 3.654 0 01-3.46-3.461l-.006-.188A3.655 3.655 0 017.385 4l.187.005a3.654 3.654 0 013.466 3.65l-.005.187a3.654 3.654 0 01-3.648 3.466v-2c.913 0 1.653-.74 1.653-1.654zM27.308 7.654a1.654 1.654 0 10-1.654 1.654v2l-.188-.005a3.654 3.654 0 01-3.461-3.461L22 7.654A3.655 3.655 0 0125.654 4l.188.005a3.654 3.654 0 013.466 3.65l-.005.187a3.654 3.654 0 01-3.649 3.466v-2c.913 0 1.654-.74 1.654-1.654zM5.003 11.937a1 1 0 111.11 1.664 4.655 4.655 0 00-2.045 3.359l-.074.67a1 1 0 01-1.988-.22l.074-.67a6.655 6.655 0 012.923-4.803zM10.132 11.937a1 1 0 10-1.11 1.664 4.655 4.655 0 012.044 3.359l.075.67a1 1 0 001.988-.22l-.074-.67a6.655 6.655 0 00-2.923-4.803z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 17v2H1v-2h21zM16 12.25h2v3.5h-2v-3.5z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14v-2h4v2h-4zM17 14a3 3 0 013 3h-2a1 1 0 10-2 0h-2a3 3 0 013-3zM29 15a1 1 0 00-1-1h-4a1 1 0 00-1 1v7h-2v-7a3 3 0 013-3h4a3 3 0 013 3v7h-2v-7zM25 22v8h-2v-8h2zM29 22v8h-2v-8h2z",
    fill: props.color
  }));
}

export default SvgIconPeopleReceptionFilled;